// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3p0dH","colMin":"styles_colMin__2wONg"};